import React from 'react';
import Button from '../../../../components/UI/Button/Button';
// import { showMessage } from '../../shared/utility';
// import { downloadFile } from '../../store/actions/index';
// import { JOB_SUMMARY } from '../../shared/const/Tittles/JobConfiguration';
// import * as CONST from '../../shared/const/MessegesToUser/Messages';

const EXPORT_SETTING = 'EXPORT SETTING';
// const SAVE_PACKAGE = 'SAVE PACKAGE';

const ExportSetting = (props) => {
	const exportJson = async () => {
		// const blobType = 'application/json';
		// const duration = 3;
		// await downloadFile(props.data, props.fileName, blobType);
		// showMessage(CONST.EXPORT_DOWNLOAD_SUCCESS, CONST.NOTIFICATION_TYPES.SUCCESS, duration);
		// props.onRedirect();
	};

	return (
		<div className="stage-content">
			<div className="stage-zero-btns-area">
				<Button className="project-button-short" onClick={() => exportJson()}>
					<i className="icon-release-package-action"></i>
					<label>{EXPORT_SETTING}</label>
				</Button>
			</div>
		</div>
	);
};
export default ExportSetting;
